<template>
  <span class="search-tips-info">
    <i
        class="pi pi-info-circle search-tips-icon"
        aria-label="Search tips"
        role="button"
        tabindex="0"
        @click.stop="toggle"
        @keydown.enter.prevent="toggle"
    ></i>
    <OverlayPanel
        ref="panel"
        :dismissable="true"
        appendTo="body"
        :baseZIndex="10000"
        class="search-tips-panel"
    >
      <div class="search-tips-content" data-testid="ticket-search-tips">
        <div class="search-tips-title">Search tips</div>
        <div class="search-tips-row">
          <code>#Smith</code>
          <span>customer name only</span>
        </div>
        <div class="search-tips-row">
          <code>Smith + lift</code>
          <span>all terms must match</span>
        </div>
        <div class="search-tips-row">
          <code>Smith</code>
          <span>searches ticket #, warranty #, title, customer, contact name &amp; number, equipment and the customer's contact record</span>
        </div>
      </div>
    </OverlayPanel>
  </span>
</template>

<script>
import OverlayPanel from "primevue/overlaypanel";

export default {
  name: "TicketSearchTips",
  components: {
    OverlayPanel,
  },
  methods: {
    toggle(event) {
      this.$refs.panel.toggle(event);
    },
  },
};
</script>

<style>
.search-tips-info {
  display: inline-flex;
  align-items: center;
}

.search-tips-icon {
  cursor: pointer;
  color: #6b7280;
  font-size: 1rem;
  padding: 0 0.25rem;
}

.search-tips-icon:hover {
  color: #374151;
}

.search-tips-panel .p-overlaypanel-content {
  padding: 0.75rem 1rem;
}

.search-tips-content {
  font-size: 0.85rem;
  max-width: 260px;
}

.search-tips-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.search-tips-row {
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
  margin-bottom: 0.35rem;
}

.search-tips-row:last-child {
  margin-bottom: 0;
}

.search-tips-row code {
  background: #f3f4f6;
  border-radius: 3px;
  padding: 0.1rem 0.3rem;
  white-space: nowrap;
  flex-shrink: 0;
}

.search-tips-row span {
  color: #4b5563;
}
</style>
